module.exports = __webpack_public_path__ + "img/inbox-pembayaran.02638015.svg";